import {
  GOODS_RECEIPT_LABEL,
  GOODS_RECEIPT_PATH,
  GOODS_WRITE_OFF_LABEL,
  GOODS_WRITE_OFF_PATH,
  GOODS_TRANSFER_LABEL,
  GOODS_TRANSFER_PATH,
  // DELETE_PRODUCTS_LABEL,
  // DELETE_PRODUCTS_PATH,
} from '@app/constants';
import type { GetMenuItemsProps } from '@app/pages/Warehouses/WarehouseOperations/types';

import type { MenuProps } from 'antd';

export const getMenuItems = ({
  IsProductItemsAccept,
  IsProductItemsDecomission,
  IsProductItemsMove,
}: // IsProductItemsDelete,
GetMenuItemsProps): MenuProps['items'] => [
  ...(IsProductItemsAccept
    ? [{ label: GOODS_RECEIPT_LABEL, key: GOODS_RECEIPT_PATH }]
    : []),
  ...(IsProductItemsDecomission
    ? [{ label: GOODS_WRITE_OFF_LABEL, key: GOODS_WRITE_OFF_PATH }]
    : []),
  ...(IsProductItemsMove
    ? [{ label: GOODS_TRANSFER_LABEL, key: GOODS_TRANSFER_PATH }]
    : []),
  // ...(IsProductItemsDelete
  //   ? [{ label: DELETE_PRODUCTS_LABEL, key: DELETE_PRODUCTS_PATH }]
  //   : []),
];
